import { useEffect, useState } from 'react'
import { useAuthStore } from '@auth/authStore'
import { tokenStore } from '@auth/tokenStore'
import { api } from '@api/client'

export function useAuthBootstrap () {
  const [isReady, setIsReady] = useState(false)
  const setAuth = useAuthStore(state => state.setAuth)
  const logout = useAuthStore(state => state.logout)

  // TODO: to be implemented later on
  // useEffect(() => {
  //   let cancelled = false

  //   async function bootstrap () {
  //     const refreshToken = tokenStore.getRefreshToken()

  //     if (!refreshToken) {
  //       if (!cancelled) setIsReady(true)
  //       return
  //     }

  //     try {
  //       const response = await api.post(
  //         '/auth/refresh',
  //         { refreshToken },
  //         { _retry: true }
  //       )  //       const result = response.data.result

  //       if (result) {
  //         tokenStore.setTokens(result.AccessToken, result.IdToken)
  //         const current = useAuthStore.getState()
  //         setAuth({
  //           user: result.UserID ?? current.user,
  //           userFirstName: result.UserFirstName ?? current.userFirstName,
  //           userLastName: result.UserLastName ?? current.userLastName,
  //           companyID: result.CompanyID ?? current.companyID,
  //           companyName: result.CompanyName ?? current.companyName,
  //           isAuthenticated: true
  //         })
  //       } else {
  //         logout()
  //       }
  //     } catch (err) {
  //       logout()
  //     } finally {
  //       if (!cancelled) setIsReady(true)
  //     }
  //   }

  //   bootstrap()
  //   return () => {
  //     cancelled = true
  //   }
  // }, [setAuth, logout])

  useEffect(() => {
    if (tokenStore.getAccessToken()) {
      setAuth({ isAuthenticated: true })
    } else {
      logout()
    }
    setIsReady(true)
  }, [setAuth, logout])

  return isReady
}
